/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {Workflow, WorkflowFromJSON, WorkflowToJSON,} from './Workflow';

/**
 *
 * @export
 * @interface WorkflowApiResult
 */
export interface WorkflowApiResult {
    /**
     *
     * @type {boolean}
     * @memberof WorkflowApiResult
     */
    success?: boolean;
    /**
     *
     * @type {Workflow}
     * @memberof WorkflowApiResult
     */
    content?: Workflow;
    /**
     *
     * @type {string}
     * @memberof WorkflowApiResult
     */
    message?: string | null;
}

export function WorkflowApiResultFromJSON(json: any): WorkflowApiResult {
    return WorkflowApiResultFromJSONTyped(json, false);
}

export function WorkflowApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : WorkflowFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function WorkflowApiResultToJSON(value?: WorkflowApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': WorkflowToJSON(value.content),
        'message': value.message,
    };
}

